// extracted by mini-css-extract-plugin
export default {"mainPageContainer":"office_mainPageContainer__KVru5","hiddenMainPage":"office_hiddenMainPage__Brgrk","loader":"office_loader__E0C3y"};